<template>
	<div :id="id"></div>
</template>

<script>
	import E from 'wangeditor'

	export default {
		props: ['id', 'height'],
		data() {
			return {
				editor: null,
				html: ''
			}
		},
		mounted() {
			var _this = this;
			_this.editor = new E('#' + _this.id);
			// console.log(_this.editor)
			_this.editor.config.uploadImgMaxLength = 9 // 一次最多上传 9 个图片
			_this.editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'jfif']
			_this.editor.config.zIndex = 1;
			_this.editor.config.height = _this.height ? _this.height : 500;
			// console.log(_this.editor.config)

			// 自定义上传图片
			_this.editor.config.customUploadImg = function(resultFiles, insertImgFn) {
				if (resultFiles.length > 0) {
					resultFiles.forEach(function(file, index) {
						var reader = new FileReader();
						reader.readAsDataURL(file);
						reader.onload = function() {
							file.content = reader.result;
							_this.$util.uploadFile(file).then(res => {
								insertImgFn(res.data.url)
							}, err => {
								console.log(err)
							})
						}
					})
				}
			}
			//自定义上传视频
			_this.editor.config.customUploadVideo = function(resultFiles, insertVideoFn) {
				console.log(resultFiles, 'customUploadVideo')
				if (resultFiles.length > 0) {
					resultFiles.forEach(function(file, index) {
						var reader = new FileReader();
						reader.readAsDataURL(file);
						reader.onload = function() {
							file.content = reader.result;
							_this.$util.uploadVideo(file).then(res => {
								insertVideoFn(res.data.url)
							}, err => {
								console.log(err)
							})
						}
					})
				}
			}

			_this.editor.create()
		},
		methods: {
			getHtml() {
				return this.editor.txt.html()
			},
			setHtml(value) {
				this.editor.txt.html(value)
			},
		},
		beforeDestroy() {
			// 销毁编辑器
			this.editor.destroy()
			this.editor = null
		}
	}
</script>

<style>
	/* 	.w-e-text-container {
		height: auto !important;
		border: 1px solid #c9d8db;
		border-top: none;
		min-height: 300px;
	} */
</style>



// WEBPACK FOOTER //
// src/components/my-editor.vue